import { Keuzehulp } from '../keuzehulpen'

const maagklachten: Keuzehulp = {
  title: 'Keuzehulp Ik heb last van mijn maag. Wat kan ik doen?',
  basePath: '/maagklachten',
  documentTitle: 'Maagklachten',
  routes: [
    {
      path: '',
      routeId: 'P9-001',
      nextRouteId: 'P9-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/maagklachten',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om deze keuzehulp in te vullen.',
        },
        {
          title: '15 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp.',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je je aandacht er goed bij kunt houden.',
        },
        {
          title: 'Bekijk je antwoorden',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent.',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P9-002',
      nextRouteId: 'P9-003',
      type: 'chapter',
      title: 'Je maag',
      subtitle: 'Stap 1',
      description: `<p>We leggen eerst uit hoe je maag werkt. En welke maagklachten er zijn.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/mk-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoe-werkt-de-maag',
      routeId: 'P9-003',
      nextRouteId: 'P9-004',
      type: 'explanation',
      title: 'Hoe werkt je maag?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je maag ligt bovenin je buik. Je maag heeft een slijmlaag, bloedvaten en een laag spieren.</p>
          <p>Je maag maakt maagsap. Hierin zitten maagzuur en stoffen die van eten kleine nuttige stoffen voor je lichaam maken.</p>
          <p>Als je een hap eten hebt doorgeslikt, gaat het eten via je slokdarm naar je maag. Tussen je slokdarm en maag zit een kringspier. Die zorgt ervoor dat er eten of drinken naar je maag kan. En dat er geen maagsap in je slokdarm komt.</p>
          <p>Je maag kneedt het eten tot het naar je darmen gaat.</p>
        </div>
      `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/hoe-werkt-de-maag.mp4',
          soundSrc: 'https://media.thuisarts.nl/hoe-werkt-de-maag.mp3',
          poster: 'https://media.thuisarts.nl/hoe-werkt-de-maag.jpg',
          videoSize: '49mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/hoe-werkt-de-maag.vtt',
              subtitleSize: '1kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-1/klachten-van-de-maag',
      routeId: 'P9-004',
      nextRouteId: 'P9-005',
      type: 'explanation',
      title: 'Last van je maag',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0">Je merkt meestal 1 van deze dingen:</p>
          <ul>
            <li>pijn bovenin je buik (maagpijn) </br> Dit kan 's nachts erger worden. Na het eten kan het minder worden. Of juist erger.</li>
            <li>pijn of een branderig gevoel achter je borstbeen (brandend maagzuur) </br> Bijvoorbeeld als je bukt of na het eten gaat liggen.</li>
            <li>zuur eten of drinken uit je maag komt in je keel of mond </br> Bijvoorbeeld als je bukt of na het eten gaat liggen.</li>
          </ul>

          <p style="margin-bottom: 0">Je kunt ook 1 of meer van deze dingen hebben:</p>
          <ul>
            <li>een opgeblazen gevoel</li>
            <li>misselijk zijn</li>
            <li>overgeven</li>
            <li>snel een vol gevoel na het eten</li>
            <li>pijn of een branderig gevoel in je keel</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/waardoor-kunnen-maagklachten-komen',
      routeId: 'P9-005',
      nextRouteId: 'P9-006',
      type: 'explanation',
      hideFromOverview: true,
      title: 'Waardoor kun je last hebben van je maag?',
      titleAlign: 'center',
      description: `
        <p>Je kunt last hebben van je maag door veel dingen:</p>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Roken, alcohol en eten</h2>
        <p style="margin-top: 0;">Van roken, alcohol en frisdrank met prik kun je last krijgen van je maag. Je kunt ook meer last hebben na vet of pittig eten. Of na het eten van ui, chocola, pepermunt of zuur fruit zoals sinaasappel.</p>

        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Meer druk op je buik</h2>
        <p style="margin-bottom: 0; margin-top: 0;">Door meer druk op je buik kan eten makkelijker omhoog komen. Meer druk kan hierdoor komen:</p>
        <ul>
          <li>te zwaar zijn (overgewicht)</li>
          <li>hoesten</li>
          <li>zwangerschap</li>
        </ul>

        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Bijwerking van medicijnen</h2>
        <p style="margin-bottom: 0; margin-top: 0;">Zoals:</p>
        <ul>
          <li>pijnstillers, zoals ibuprofen, naproxen of diclofenac (NSAID's)</li>
          <li>medicijnen tegen bacteriën (antibiotica)</li>
          <li>medicijnen tegen depressie</li>
          <li>medicijn bij diabetes (metformine)</li>
          <li>medicijnen tegen hoge bloeddruk</li>
          <li>plaspillen (spironolacton)</li>
          <li>sterke medicijnen tegen ontstekingen (prednison)</li>
          <li>bloedverdunners (DOAC's)</li>
        </ul>

        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Andere oorzaken</h2>
        <p style="margin-top: 0;">Je kunt last hebben van je maag doordat je maag langzamer werkt. Of doordat de spier tussen je maag en slokdarm wat slapper is. </br> Bij een middenrif-breuk kun je ook last hebben van je maag. De bovenkant van je maag steekt dan een beetje boven je middenrif uit.</p>

        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Maagzweer of maagkanker</h2>
        <p style="margin-top: 0;">Soms heb je last van je maag door een wondje in je maag: een maagzweer. Die ontstaat meestal door pijnstillers, zoals ibuprofen, of door de maagbacterie. </br> Heel soms komen maagklachten door maagkanker. Bij maagkanker heb je meestal ook %MODALLINK%.</p>

        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Niet door stress</h2>
        <p style="margin-top: 0;">Maagklachten ontstaan niet door angst, somberheid of stress. Maar als je deze klachten hebt, heb je soms wel meer last van je maag.</p>
      `,
      align: 'left',
      modalLink: 'andere klachten',
      modalHeader: 'Klachten die kunnen passen bij maagkanker',
      modalText: `
          <p style="margin-bottom: 0;">Deze klachten kunnen passen bij maagkanker:</p>
          <ul style="margin-top: 0;">
            <li>zwarte poep</li>
            <li>bloed overgeven</li>
            <li>het gevoel dat je eten niet goed zakt</li>
            <li>pijn achter je borstbeen </li>
            <li>afvallen zonder dat je het wilt</li>
            <li>bloedarmoede</li>
          </ul>`,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/waar-wil-je-meer-over-weten',
      routeId: 'P9-006',
      nextRouteId: 'P9-007',
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wil je meer over weten?',
      description: `
        <p>Je kunt meer onderwerpen kiezen.</p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Wat kun je zelf doen?',
              showChapter: '2',
            },
            {
              title: 'Is onderzoek nodig?',
              showChapter: '3',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P9-007',
      nextRouteId: 'P9-008',
      type: 'chapter',
      title: 'Wat kun je zelf doen?',
      subtitle: 'Stap 2',
      description: `
        <p>Ontdek wat je zelf kunt doen om minder last te hebben van je maag.</p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/mk-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/stop-met-pijnstillers',
      routeId: 'P9-008',
      nextRouteId: 'P9-009',
      type: 'explanation',
      showAdviceInOverview: true,
      title: 'Stop met de pijnstillers ibuprofen, diclofenac of naproxen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Slik je bij pijn wel eens een pijnstiller tegen ontstekingen, zoals ibuprofen of diclofenac? Dan is de kans groot dat je daardoor last hebt van je maag.</p>
          <ul>
            <li>Je kunt die pijnstillers tegen ontstekingen beter niet meer slikken.</li>
            <li>Als je een pijnstiller wilt, slik dan paracetamol. </br> Daarvan krijg je geen last van je maag.</li>
          </ul>
          <p>Heb je een ziekte? En moet je daarom deze medicijnen slikken? Dan kun je niet zomaar met je medicijnen stoppen. Bespreek met je huisarts wat je kunt doen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/producten-die-maagklachten-erger-kunnen-maken',
      routeId: 'P9-009',
      nextRouteId: 'P9-010',
      type: 'explanation',
      showAdviceInOverview: true,
      title: 'Zoek uit door welk eten of drinken je meer last krijgt van je maag',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Drink geen frisdrank met prik. Daar krijg je last van je maag van.</p>
          <p style="margin-bottom: 0;">Door dit drinken of eten kun je meer last krijgen van je maag:</p>
          <ul style="margin-top: 0;">
            <li>alcohol</li>
            <li>sap, zoals sinaasappelsap</li>
            <li>pittig eten</li>
            <li>vet eten</li>
            <li>zuur fruit, zoals mandarijn, sinaasappel, citroen</li>
            <li>ui</li>
            <li>chocola</li>
            <li>pepermunt</li>
          </ul>

          <p>Kies 1 ding en drink of eet dat een tijdje niet meer. Bijvoorbeeld 2 weken. Zo kun je uitzoeken of je er meer last van je maag door krijgt.</p>
          <ul>
            <li>Krijg je minder last van je maag? Dan komt dan waarschijnlijk doordat je dit product niet meer eet of drinkt. Wil je dat zeker weten? Eet en drink het dan weer een tijdje wel. Als je toch weer last krijgt van je maag, weet je dat het daardoor komt.</li>
            <li>Merk je geen verschil als je iets een tijdje niet meer eet of drinkt? Probeer het dan met iets anders uit de lijst hierboven.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/voedingsadviezen',
      routeId: 'P9-010',
      nextRouteId: 'P9-011',
      type: 'explanation',
      title: 'Voedingsadviezen',
      align: 'left',
      titleAlign: 'center',
      videos: [
        {
          src: 'https://media.thuisarts.nl/voedingsadviezen-bij-maagklachten.mp4',
          soundSrc: 'https://media.thuisarts.nl/voedingsadviezen-bij-maagklachten.mp3',
          poster: 'https://media.thuisarts.nl/voedingsadviezen-bij-maagklachten.jpg',
          videoSize: '40.9mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/voedingsadviezen-bij-maagklachten.vtt',
              subtitleSize: '2kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P9-011',
      nextRouteId: 'P9-012',
      title: 'Klachten als je ligt',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <p>Je hebt vooral last van je maag als je ligt.</p>
            <ul>
              <li>Leg extra kussens onder je hoofd, nek en schouders. Of zet het hoofdeinde van je bed een stukje hoger. Dan ligt je hoofd hoger. Zo kan maagzuur minder makkelijk omhoog naar je mond komen.</li>
              <li>Eet niet net voor je gaat slapen. </br> Je hebt meer kans op brandend maagzuur als je met een volle maag gaat liggen. Eet dus liever niet net voordat je gaat slapen.</li>
            </ul>
          `,
        },
        {
          title: 'Nee',
          feedback: `<p>Dat is fijn. Je kunt door naar het volgende onderwerp.</p>`,
        },
      ],
      descriptionAlign: 'left',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Heb je vooral last van je maag als je ligt?</h2>
        <p style="margin-top: 0;">Bijvoorbeeld in bed.</p>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-2',
      routeId: 'P9-012',
      nextRouteId: 'P9-013',
      title: 'Roken',
      type: 'feedbackQuestion',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6;">Rook je?</h2>
      `,
      descriptionAlign: 'left',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <p>Stop met roken. Van roken kun je last krijgen van je maag.</p>
            <ul>
              <li>Vraag hulp om te stoppen met roken van een stoppen-met-roken-coach, je huisarts of de praktijkondersteuner.</li>
              <li>Je kunt ook kauwgom of pleisters met nicotine gebruiken.</li>
              <li>Soms kun je medicijnen gebruiken om te stoppen.</li>
            </ul>
            <p>Met hulp is de kans dat het lukt het grootst. Kijk verder bij <a href="https://www.thuisarts.nl/stoppen-met-roken/ik-wil-misschien-stoppen-met-roken-0" target="_blank">stoppen met roken</a>.</p>
          `,
        },
        {
          title: 'Nee',
          feedback: `<p>Goed dat je niet rookt.</p>`,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-3',
      routeId: 'P9-013',
      nextRouteId: 'P9-014',
      title: 'Je gewicht',
      type: 'feedbackQuestion',
      description: `
          <h2 style="font-size: 18px; line-height: 1.6;">Ben je te zwaar?</h2>
          <p>Tip:</br>Om te weten of je te zwaar bent, kun je <a href="https://www.voedingscentrum.nl/bmi" target="_blank">je BMI berekenen</a>. Daarvoor moet je je leeftijd, lengte en gewicht invullen. Bij een BMI van 25 of hoger ben je te zwaar.</p>
        `,
      descriptionAlign: 'left',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <p>Te zwaar zijn zorgt voor druk op je buik. Dan kun je meer last hebben van je maag. Probeer af te vallen. Bekijk de film <a href="https://www.thuisarts.nl/overzicht/film/gezond-afvallen-doe-je-zo" target="_blank"> Afvallen doe je zo </a>.
          `,
        },
        {
          title: 'Nee',
          feedback: `<p>Goed dat je een gezond gewicht hebt. Want als je te zwaar bent, kun je meer last krijgen van je maag.</p>`,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-4',
      routeId: 'P9-014',
      nextRouteId: 'P9-015',
      title: 'Angst, somberheid en stress',
      type: 'feedbackQuestion',
      description: `
          <h2 style="font-size: 18px; line-height: 1.6;">Heb je vaak last van angst, somberheid of stress?</h2>
        `,
      descriptionAlign: 'left',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <p>Door angst, somberheid en stress kun je meer last hebben van je maag.</p>
            <p>Heb je deze gevoelens vaak? Maak een afspraak met je huisarts.</p>
            <p style="margin-bottom: 0">Deze adviezen kunnen ook helpen:</p>
            <ul>
              <li>Praat erover met anderen.</li>
              <li>Beweeg veel, ook buiten.</li>
              <li>Doe je dagelijkse dingen op vaste tijden, zoals uit bed gaan, eten en naar bed gaan.</li>
              <li>Slaap je slecht? De <a href="https://www.thuisarts.nl/slecht-slapen/ik-wil-beter-slapen-slaapadviezen" target="_blank">slaapadviezen</a> kunnen helpen.</li>
              <li>Doe oefeningen om te ontspannen, zoals mindfulness-oefeningen.</li>
            </ul>
            <p>Als je je psychisch weer beter voelt, heb je waarschijnlijk ook minder last van je maag.</p>
          `,
        },
        {
          title: 'Nee',
          feedback: `<p>Fijn dat je deze gevoelens niet vaak hebt. Door angst, somberheid en stress kun je namelijk meer last krijgen van je maag.</p>`,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-5',
      routeId: 'P9-015',
      nextRouteId: 'P9-016',
      title: 'Last van je maag door medicijnen',
      type: 'feedbackQuestion',
      description: `
          <p>Van sommige medicijnen kun je last krijgen van je maag. Of ze kunnen je maag beschadigen. Bijvoorbeeld:</p>
          <ul>
            <li>NSAID-pillen, zoals ibuprofen, naproxen of diclofenac </li>
            <li>medicijnen tegen depressie</li>
            <li>medicijnen tegen hoge bloeddruk</li>
            <li>bloedverdunners (DOAC's)</li>
            <li>de plaspil spironolacton</li>
            <li>sterke medicijnen tegen ontstekingen (prednison)</li>
          </ul>
          <h2 style="font-size: 18px; line-height: 1.6;">Gebruik je 1 of meer van deze medicijnen? Of heb je andere medicijnen en denk je dat je daar last van je maag door hebt?</h2>
        `,
      descriptionAlign: 'left',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <p>Je gebruikt medicijnen waarvan je misschien last hebt van je maag. Bespreek dan met je huisarts welke medicijnen je gebruikt. Ook als je ze zelf gekocht hebt in de winkel of apotheek.</p>

            <p>Bekijk samen wat je het beste kunt doen. Soms kun je minder of andere medicijnen slikken. Soms kun je een extra medicijn krijgen dat je maag beschermt.</p>

            <p>Stop nooit zomaar met een medicijn. Bespreek dit altijd eerst met je huisarts.</p>
          `,
        },
        {
          title: 'Nee',
          feedback: `<p>Fijn dat je deze medicijnen niet slikt.</p>`,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/medicijnen-tegen-maagklachten',
      routeId: 'P9-016',
      nextRouteId: 'P9-017',
      type: 'explanation',
      title: 'Medicijnen om minder last te hebben van je maag',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>De adviezen kunnen helpen om minder last te krijgen van je maag. Je kunt daarbij ook een maagmedicijn proberen als je dat wilt.</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/maagmedicijn-proberen',
      routeId: 'P9-017',
      nextRouteId: 'P9-018',
      type: 'explanation',
      title: 'Een maagmedicijn proberen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Veel maagmedicijnen kun je kopen bij de winkel of apotheek zonder recept van je huisarts. </br> Gebruik je al andere medicijnen? Of heb je een ziekte? Vraag dan eerst bij de apotheek of je ook een maagmedicijn mag.</p>

          <p>Er zijn verschillende soorten maagmedicijnen.</p>

          <ol>
            <li>
              <p>Begin met een maagzuur-binder. Dit medicijn heet algeldraat met magnesiumhydroxide. Kijk op <a href="https://www.apotheek.nl/medicijnen/algeldraat-met-magnesiumhydroxide#onder-welke-namen-is-algeldraat-met-magnesiumhydroxide-verkrijgbaar" target="_blank">apotheek.nl<a/>
                welke namen er op het doosje kunnen staan. </br>Een maagzuur-binder maakt alles wat in je maag zit minder zuur. Er zijn drankjes en pillen waar je op kunt kauwen.
              </p>
              <ul>
                <li>Neem het drankje of de pil 1 uur na elke maaltijd. En voordat je gaat slapen.</li>
                <li>Je kunt dit 2 weken doen en dan stoppen.</li>
              </ul>
            </li>

            <li>
              <p>Helpt de maagzuur-binder niet genoeg? Probeer dan een maag-beschermer. Bijvoorbeeld sucralfaat als poeder of drankje. </br> Dit maakt een bescherm-laagje op de binnenkant van je maag.</p>
              <ul>
                <li>Slik de maag-beschermer voor elke maaltijd. En voordat je gaat slapen.</li>
                <li>Je kunt dit 2 weken doen en kijken hoe het dan gaat.</li>
              </ul>
            </li>
          </ol>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Koop geen andere middelen</h2>
          <p style="margin-top: 0;">Slik geen middel met alcohol en kruiden (Iberogast). Het is niet zeker dat dit helpt.</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/testen-maagbacterie',
      routeId: 'P9-018',
      nextRouteId: 'P9-019',
      type: 'explanation',
      title: 'Testen of je de maagbacterie hebt ',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Heb je een maagzuur-binder en een maag-beschermer geprobeerd? En gaat het na een paar weken niet beter? Praat met je huisarts. Bijvoorbeeld over welke adviezen je geprobeerd hebt. En welke maagmedicijnen.</p>

          <p>Er is misschien een %MODALLINK%. </br>Heb je de maagbacterie? Dan krijg je van je huisarts medicijnen om die bacterie weg te halen. </br>Heb je de maagbacterie niet? Dan kun je een maagzuur-remmer proberen.</p>
        </div>
        `,
      modalLink: 'test nodig om te weten of je de maagbacterie hebt',
      modalHeader: 'Onderzoek naar de maagbacterie',
      modalText: `
            <p>De meeste mensen krijgen een poeptest.</p>
            <ul>
              <li>Je krijgt een potje van je huisarts of het laboratorium. Er zit een lepeltje bij.</li>
              <li>Je vangt je poep op. Bijvoorbeeld in een bakje of op een wc-papiertje in de wc.</li>
              <li>Je vult de helft van het potje met je poep.</li>
            </ul>

            <p>Je levert het potje in bij je huisarts of het laboratorium. Soms moet je het potje opsturen met de post.</p>
          `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/nadelen-van-maagzuur-remmers',
      routeId: 'P9-019',
      nextRouteId: 'P9-020',
      type: 'explanation',
      title: 'Maagzuur-remmers',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Als je de maagbacterie niet hebt, kun je een maagzuur-remmer krijgen. Bijvoorbeeld omeprazol of pantoprazol. Artsen noemen dit een PPI.</p>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen van maagzuur-remmers</h2>
          <ul style="margin-top: 0;">
            <li>Je kunt hoofdpijn en buikpijn krijgen.</li>
            <li>Je hebt een grotere kans op ontstekingen van je maag en darmen door bacteriën en virussen. Bijvoorbeeld door voedselvergiftiging. Dit komt omdat je minder maagzuur hebt. En maagzuur beschermt je tegen bacteriën en virussen.</li>
          </ul>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Niet te lang slikken</h2>
          <p style="margin-top: 0;">Slik de maagzuur-remmer niet langer dan 4 weken. Je went eraan en als je het medicijn langer slikt, wordt het lastiger om er weer mee te stoppen. </br> Ook kunnen deze maagzuur-remmers vervelende bijwerkingen geven als je ze lang gebruikt. Zoals botontkalking, te weinig vitamine B12 in je bloed of nierschade.</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P9-020',
      nextRouteId: 'P9-021',
      type: 'chapter',
      title: 'Is er onderzoek nodig als je last hebt van je maag?',
      subtitle: 'Stap 3',
      description: `<p>Meestal zijn maagklachten niet gevaarlijk en gaan ze vanzelf over. Soms is er wel onderzoek nodig.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/mk-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/kan-het-kwaad',
      routeId: 'P9-021',
      nextRouteId: 'P9-022',
      type: 'explanation',
      title: 'Zijn maagklachten gevaarlijk?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Misschien ben je bang dat je last hebt van je maag door een erge ziekte. Zoals maagkanker of slokdarmkanker.</p>
          <p>Meestal zijn er bij deze ziektes ook ernstige klachten, zoals zwarte poep of bloed overgeven. %MODALLINK%</p>
        </div>
        `,
      modalLink: 'Kijk bij welke klachten je de huisarts moet bellen.',
      modalHeader: 'Bij welke klachten moet je de huisarts bellen?',
      modalText: `
        <p>Deze klachten kunnen passen bij maagkanker of slokdarmkanker:</p>
        <ul>
          <li>zwarte poep</li>
          <li>bloed overgeven</li>
          <li>het gevoel dat je eten niet goed zakt</li>
          <li>pijn achter je borstbeen</li>
          <li>afvallen zonder dat je daar moeite voor doet</li>
          <li>bloedarmoede</li>
        </ul>
        `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/maagklachten-kan-het-kwaad.mp4',
          soundSrc: 'https://media.thuisarts.nl/maagklachten-kan-het-kwaad.mp3',
          poster: 'https://media.thuisarts.nl/maagklachten-kan-het-kwaad.jpg',
          videoSize: '22.5mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/maagklachten-kan-het-kwaad.vtt',
              subtitleSize: '2kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/is-er-onderzoek-nodig',
      routeId: 'P9-022',
      nextRouteId: 'P9-023',
      type: 'explanation',
      title: 'Is er onderzoek nodig?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Heb je de adviezen uit deze keuzehulp 3 weken gedaan? En gaat het niet beter? Maak dan een afspraak met je huisarts. Er is misschien een test nodig om te weten of je de maagbacterie hebt.</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/onderzoek-naar-de-maagbacterie',
      routeId: 'P9-023',
      nextRouteId: 'P9-024',
      type: 'explanation',
      title: 'Onderzoek naar de maagbacterie',
      align: 'left',
      titleAlign: 'center',
      description: `
          <p style="margin-bottom: 0">Je krijgt onderzoek naar de maagbacterie in 1 van de volgende situaties:</p>
          <ul style="margin-bottom: 0; display: inline-block;">
            <li>Je hebt voor het eerst last van je maag en je gaat een maagzuur-remmer slikken, zoals omeprazol.</li>
            <li>Je woonde in je kindertijd in %MODALLINK%. </li>
            <li>Je hebt medicijnen geslikt tegen de maagbacterie. De test laat dan zien of de bacterie weg is.</li>
          </ul>
        `,
      modalLink: 'een gebied waar veel mensen de maagbacterie hebben',
      modalHeader: 'Gebieden waar veel mensen de maagbacterie hebben',
      modalText: `
          <ul>
            <li>landen rond de Middellandse Zee, zoals Frankrijk, Spanje en Italië </li>
            <li>Oost-Europa, zoals Polen, Roemenië en Tsjechië </li>
            <li>het Midden-Oosten, zoals Syrië, Irak en Iran</li>
            <li>Azië</li>
            <li>Afrika</li>
            <li>Midden-Amerika</li>
            <li>Zuid-Amerika</li>
          </ul>`,
      info: [
        {
          urlText: 'Hoe gaat een onderzoek naar de maagbacterie?',
          title: 'Onderzoek naar de maagbacterie',
          content: `<div>
            <p>De meeste mensen krijgen een poeptest.</p>
            <ul>
              <li>Je krijgt een potje van je huisarts of het laboratorium. Er zit een lepeltje bij.</li>
              <li>Je vangt je poep op. Bijvoorbeeld in een bakje of op een wc-papiertje in de wc.</li>
              <li>Je vult de helft van het potje met je poep.</li>
              <li>Je levert het potje in bij je huisarts of het laboratorium. Soms moet je het potje opsturen met de post.</li>
            </ul>
          </div>`,
        },
        {
          urlText: 'Wat moet je doen voor het onderzoek?',
          title: 'Wat moet je doen voor het onderzoek?',
          content: `
            <div>
              <p>Sommige medicijnen zorgen ervoor dat de uitslag van onderzoek naar de maagbacterie niet klopt. De uitslag kan dan zijn dat je de bacterie niet hebt, terwijl de bacterie wel in je maag zit. </p>

              <p style="margin-bottom:0;">Dit zijn de adviezen:</p>
              <ul style="margin-top:0;">
                <li>Je mag in de 4 weken voor de test geen medicijnen tegen bacteriën (antibiotica) slikken.</li>
                <li>Slik je een maagzuur-remmer, zoals omeprazol? Stop daar 2 weken voor de test mee.</li>
                <li>Slik je een maagzuur-remmer, zoals famotidine? Stop daar 1 dag voor de test mee.</li>
              </ul>

              <p>Je kunt tijdelijk een ander maagmedicijn slikken. Bespreek dit met je huisarts.</p>
            </div>`,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/bloedonderzoek',
      routeId: 'P9-024',
      nextRouteId: 'P9-025',
      type: 'explanation',
      title: 'Bloedonderzoek',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Soms wil je huisarts weten of je bloedarmoede hebt. Laat dan je bloed prikken.</p>
          <p>Bloedarmoede kan bijvoorbeeld komen doordat je al lange tijd wat bloed verliest via je maag. Bijvoorbeeld door een wondje in je maag (maagzweer).</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/kijkonderzoek-van-de-maag',
      routeId: 'P9-025',
      nextRouteId: 'P9-026',
      type: 'explanation',
      title: 'Test wat je al weet over een kijkonderzoek van je maag',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je krijgt een kijkonderzoek van je maag als je erge klachten hebt. Zoals zwarte poep, bloed overgeven, pijn als je eten doorslikt. Of als je bloedarmoede hebt of afvalt zonder dat je daar moeite voor doet.</p>
          <p>Heb je dat soort klachten niet, dan krijg je soms ook een kijkonderzoek.</p>
          <p>Wat weet je al over een kijkonderzoek van je maag?</p>
          <p>Er komen nu 4 vragen.</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P9-026',
      nextRouteId: 'P9-027',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Vraag',
      title: 'Waar kijkt de arts vooral naar bij een kijkonderzoek van je maag?',
      quizAnswers: ['A: hoe goed je maag werkt', 'B: het slijmvlies van je maag'],
      correctQuizAnswer: 'B: het slijmvlies van je maag',
      explanation:
        'De arts bekijkt het slijmvlies aan de binnenkant van je maag. Met dit onderzoek kan de arts niet goed zien of je maag goed werkt.',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P9-027',
      nextRouteId: 'P9-028',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Vraag',
      title:
        'Met een kijkonderzoek kan een arts meestal zien waardoor maagklachten komen. Klopt dat?',
      quizAnswers: ['A: ja', 'B: nee'],
      correctQuizAnswer: 'B: nee',
      explanation:
        'Met een kijkonderzoek is bij weinig mensen te zien waardoor ze last hebben van hun maag. Bij dit onderzoek kijkt de arts naar de binnenkant van de maag (het slijmvlies). De arts kijkt of het er gezond uitziet of dat er een wondje zit, een ontsteking of een plek die kanker kan zijn.',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P9-028',
      nextRouteId: 'P9-029',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Vraag',
      title:
        '100 mensen hebben last van hun maag, maar geen %MODALLINK%. Zij krijgen een kijkonderzoek. Bij hoeveel van die 100 mensen is de uitslag dat ze kanker van hun maag of slokdarm hebben, denk je?',
      quizAnswers: ['A: 2 mensen', 'B: 20 mensen', 'C: 50 mensen'],
      correctQuizAnswer: 'A: 2 mensen',
      explanation:
        'Bij de meeste mensen komen hun maagklachten niet door kanker. Bij mensen die wel maagkanker hebben, komen er vaak andere erge klachten bij. Zoals zwarte poep, bloed overgeven en gewicht verliezen.',
      modalLink: 'ernstige klachten',
      modalHeader: 'Ernstige klachten',
      modalText: `
          <p style="margin-bottom: 0">Ernstige klachten zijn bijvoorbeeld:</p>
          <ul style="margin-top: 0">
            <li>plakkerige en zwarte poep</li>
            <li>bloed overgeven (bloed braken)</li>
            <li>het eten blijft hangen of zakt niet goed</li>
            <li>gewicht verliezen zonder dat je daar moeite voor doet</li>
          </ul>`,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-4',
      routeId: 'P9-029',
      nextRouteId: 'P9-030',
      hideFromOverview: true,
      type: 'quizQuestion',
      subtitle: 'Vraag',
      title:
        'Een kijkonderzoek van je maag kan ervoor zorgen dat je minder last hebt van je maag. Klopt dat?',
      quizAnswers: ['A: ja', 'B: nee'],
      correctQuizAnswer: 'B: nee',
      explanation:
        'Tijdens een kijkonderzoek kijkt een arts met een camera in je maag. Kijken is geen behandeling. Je klachten worden dus niet minder door een kijkonderzoek.',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/kijkonderzoek-van-de-maag-2',
      routeId: 'P9-030',
      nextRouteId: 'P9-031',
      type: 'explanation',
      title: 'Kijkonderzoek van je maag',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je krijgt een kijkonderzoek van je maag als je erge klachten hebt. Zoals zwarte poep of bloed overgeven.</br> Heb je dat soort klachten niet, dan krijg je meestal geen kijkonderzoek.</p>
        </div>
        `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wanneer-krijg-je-een-kijkonderzoek',
      routeId: 'P9-031',
      nextRouteId: 'P9-032',
      type: 'explanation',
      title: 'Wanneer krijg je een kijkonderzoek van je maag?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0;">Je krijgt een kijkonderzoek van je maag als je 1 of meer van deze klachten hebt:</p>
          <ul style="margin-top: 0;">
            <li>zwarte poep</li>
            <li>bloed overgeven</li>
            <li>pijn als je eten doorslikt</li>
            <li>bloedarmoede</li>
            <li>afvallen zonder dat je dat wilt</li>
          </ul>

          <p style="margin-bottom: 0;">Heb je dat soort klachten niet, dan krijg je een kijkonderzoek als deze 3 dingen voor jou zo zijn:</p>
          <ul style="margin-top: 0;">
            <li>Je hebt langer dan 2 maanden of steeds weer last van je maag.</li>
            <li>Je hebt de maagbacterie niet.</li>
            <li>Je hebt een grotere kans op maagkanker of slokdarmkanker. </br> Bijvoorbeeld omdat je ouder dan 50 jaar bent, rookt, veel alcohol drinkt of bestraling voor borstkanker hebt gehad.</li>
          </ul>
          <p>Heeft je vader, moeder, broer of zus maagkanker? Of maagkanker gehad? Dan laat je huisarts ook een kijkonderzoek doen als je maagklachten hebt.</p>
          <p>Heb je weinig kans op maagkanker of slokdarmkanker? Dan is een kijkonderzoek van je maag niet nodig. Met een kijkonderzoek is meestal niet te zien waardoor je last hebt van je maag.</p>
        </div>
        `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/heeft-een-kijkonderzoek-van-de-maag-zin.mp4',
          soundSrc: 'https://media.thuisarts.nl/heeft-een-kijkonderzoek-van-de-maag-zin.mp3',
          poster: 'https://media.thuisarts.nl/heeft-een-kijkonderzoek-van-de-maag-zin.jpg',
          videoSize: '21.4mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/heeft-een-kijkonderzoek-van-de-maag-zin.vtt',
              subtitleSize: '2kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-gaat-een-kijkonderzoek-van-de-maag',
      routeId: 'P9-032',
      nextRouteId: 'P9-033',
      type: 'explanation',
      title: 'Hoe gaat een kijkonderzoek van de maag?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Voor een kijkonderzoek van je maag verdooft een verpleegkundige meestal je keel met een spray. Daardoor moet je minder kokhalzen tijdens het onderzoek.</p>
          <p>De arts schuift een slangetje met camera door je keel naar je maag. Op een beeldscherm kan de arts zien wat de camera filmt. Soms haalt de arts ook een stukje slijmvlies weg uit de binnenkant van je maag om te onderzoeken.</p>
        </div>
        `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/hoe-gaat-een-kijkonderzoek-van-de-maag.mp4',
          soundSrc: 'https://media.thuisarts.nl/hoe-gaat-een-kijkonderzoek-van-de-maag.mp3',
          poster: 'https://media.thuisarts.nl/hoe-gaat-een-kijkonderzoek-van-de-maag.jpg',
          videoSize: '49.1mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/hoe-gaat-een-kijkonderzoek-van-de-maag.vtt',
              subtitleSize: '1kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/lang-last-van-je-maag',
      routeId: 'P9-033',
      nextRouteId: 'P9-034',
      type: 'explanation',
      title: 'Lang last van je maag',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Soms heb je langer dan 2 maanden of steeds weer last van je maag. Er is vaak geen lichamelijke oorzaak te vinden. Zoals een ziekte of beschadiging die past bij waar je last van hebt.</p>
          <a href="https://www.thuisarts.nl/maagklachten/ik-heb-lang-last-van-mijn-maag-of-maagzuur" target="_blank">Kijk wat je zelf kunt doen als je lang last hebt van je maag.</a>
        </div>
        `,
      button: 'Door naar je antwoorden',
    },
    {
      path: '/print-overview',
      routeIndex: '4',
      routeId: 'P9-034',
      nextRouteId: 'end',
      type: 'end',
      header: {
        title: 'Je antwoorden bij deze keuzehulp',
        description: `
          <p>Je bent nu klaar met de keuzehulp. De adviezen kun je lezen of printen. Klik op 1 van de knoppen hieronder.</p>
          <p>Heb je nog vragen? Kijk dan op Thuisarts.nl of bespreek ze met je huisarts.</p>
        `,
      },
    },
  ],
}

export default maagklachten
